export default __webpack_public_path__ + "static/dark-kitchen-presentation-5e00577570023e1562df75f4e7c01c4c.png";